
export class CorrectionDto {
	id;
    kind;
    rate;
    base;
    wrongExpenditure;
    influenceCurrent;
    influenceFuture;
    finding;
    paymentClaim;
    order;
    pseudoId;
    indirectCosts;
    projectNumber;
}


















